module.exports = __webpack_public_path__ + "img/MADDEN23-banner_day1.d5b2a91c.png";